  <rds-avatar-group>
    <rds-avatar *ngFor="let user of visibleUsers" [rdsTooltip]="user.name" [rdsTooltipShowDelay]="300">
      <img *ngIf="!!user.avatar" rds-avatar-image [src]="user.avatar" referrerpolicy="no-referrer"/>
      <span *ngIf="!user.avatar" rds-avatar-initials>{{user.name | initials}}</span>
    </rds-avatar>
    <rds-avatar *ngIf="hiddenUsers.length > 0" [rdsTooltip]="hiddenUsers | listFromArray" [rdsTooltipShowDelay]="300">
      <span rds-avatar-initials>+{{hiddenUsers.length}}</span>
    </rds-avatar>
  </rds-avatar-group>